"use client";

import { ArrowRight, Calculator, Wallet, BookOpen, ChartLine as LineChart, Compass, ShieldCheck } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicSpecialists() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    number: "01",
    title: "Architettura Web B2B",
    description: "Infrastrutture digitali progettate per la conversione, non semplici siti vetrina. Architetture solide per lead generation.",
    Icon: Calculator
  }, {
    number: "02",
    title: "SEO Internazionale",
    description: "Posizionamento strategico sui mercati esteri per intercettare buyer e partner commerciali qualificati.",
    Icon: Wallet
  }, {
    number: "03",
    title: "Neuromarketing",
    description: "Applicazione della psicologia clinica all'UX design per massimizzare l'impatto cognitivo sui decision maker.",
    Icon: BookOpen
  }, {
    number: "04",
    title: "Market Intelligence",
    description: "Analisi dei dati e dei competitor per identificare asimmetrie di mercato e opportunità di penetrazione.",
    Icon: LineChart
  }, {
    number: "05",
    title: "Ricerca Partner",
    description: "Sviluppo di reti commerciali estere attraverso l'integrazione di logistica e intelligenza digitale.",
    Icon: Compass
  }, {
    number: "06",
    title: "Export Strategy",
    description: "Consulenza direzionale per l'abbattimento delle barriere d'ingresso nei mercati globali ad alto potenziale.",
    Icon: ShieldCheck
  }];
  return <section data-section-id="241" id="strategic-specialists" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-default text-base text-muted-foreground/70">§ 02</span>
              <span className="h-px w-8 bg-primary" />
              <span className="font-mono uppercase tracking-widest text-xs text-muted-foreground">
                Intelligence & Sviluppo
              </span>
            </div>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground uppercase">
              Infrastrutture per la{" "}
              <span className="italic font-light text-primary">crescita globale.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4">
            <p className="font-default text-base md:text-lg leading-relaxed text-muted-foreground max-w-md lg:ml-auto">
              Dall'architettura web avanzata alla ricerca partner, il nostro metodo asimmetrico 
              trasforma la presenza digitale in un motore di espansione commerciale internazionale.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border">
          {services.map((service, i) => {
          const Icon = service.Icon;
          return <div key={i} data-index={i} className={`group relative bg-card p-8 md:p-10 border border-transparent hover:border-primary transition-all duration-500 ease-out hover:-translate-y-0.5 rounded-md ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
            transitionDelay: gridVisible ? `${i * 80}ms` : "0ms"
          }}>
                {}
                <span className="absolute top-6 right-6 font-default italic text-3xl text-muted-foreground/20 group-hover:text-primary transition-colors duration-500">
                  {service.number}
                </span>

                {}
                <div className="mb-10">
                  <Icon className="w-10 h-10 text-accent-foreground" strokeWidth={1.5} aria-hidden="true" />
                </div>

                {}
                <h3 className="font-default text-2xl font-semibold text-foreground mb-3 leading-snug uppercase">
                  {service.title}
                </h3>

                {}
                <p className="font-default text-sm md:text-base leading-relaxed text-muted-foreground mb-8 max-w-sm">
                  {service.description}
                </p>

                {}
                <Link to="/HomePage" className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-foreground hover:text-primary transition-colors duration-300">
                  <span>Analisi Dettagliata</span>
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
                </Link>
              </div>;
        })}
        </div>

        {}
        <div ref={ctaRef} className={`mt-16 md:mt-20 text-center transition-all duration-700 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild variant="link" className="text-foreground hover:text-primary font-mono uppercase tracking-wider text-sm h-auto p-0">
            <Link to="/HomePage" className="inline-flex items-center gap-2 group">
              <span className="border-b border-primary group-hover:border-foreground pb-1 transition-colors duration-300">
                Esplora il metodo asimmetrico
              </span>
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}